import React from 'react';
import { Modal, Table, Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';

const SelectedMetersModal = ({ show, onHide, meters }) => {
  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          <FontAwesomeIcon icon={faCheckCircle} className="me-2 text-success" />
          Selected Meters ({meters.length})
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {meters.length === 0 ? (
          <div className="text-center p-4 text-muted">
            No meters selected
          </div>
        ) : (
          <div className="table-responsive">
            <Table striped hover>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Meter ID</th>
                  <th>Meter Name</th>
                  <th>Type</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {meters.map((meter, index) => (
                  <tr key={meter.meterId}>
                    <td>{index + 1}</td>
                    <td>
                      <code>{meter.meterId}</code>
                    </td>
                    <td>{meter.meterName || '-'}</td>
                    <td>
                      <Badge bg="info">{meter.meterType || 'N/A'}</Badge>
                    </td>
                    <td>
                      <Badge bg={meter.isActive ? 'success' : 'secondary'}>
                        {meter.isActive ? 'Active' : 'Inactive'}
                      </Badge>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <div className="text-muted">
          Total: <strong>{meters.length}</strong> meter{meters.length !== 1 ? 's' : ''}
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default SelectedMetersModal;